import React from 'react';
import cx from 'classnames';

// components
import { Link } from 'src/components/Inputs';
import ArrowRightSingleSmall from 'src/components/SVGs/Icons/ArrowRightSingleSmall';
import Image from 'src/components/Image';

//helper
import { optimizeImage } from 'src/lib/image-helpers';

const Quote = (props) => {
  return (
    <div
      className={cx('quote-section', props.classes, {
        'with-background': props['with-background'],
        'quote-section-dark': props['is-dark'],
        [`with-background-color quote-section--${props['bg-color']}`]:
          props['bg-color'],
      })}
      style={{
        //variables declared here are used as background image for '.quote-section' selector in '_quote.scss'
        '--bg-quote-left': `url(${optimizeImage(
          '/assets/img/backgrounds/quote-background-left.svg',
        )})`,
        '--bg-quote-right': `url(${optimizeImage(
          '/assets/img/backgrounds/quote-background-right.png',
        )})`,
        '--quote-open-icon': `url(${optimizeImage(
          '/assets/img/icons/quote-open-icon.svg',
        )})`,
        '--quote-close-icon': `url(${optimizeImage(
          '/assets/img/icons/quote-close-icon.svg',
        )})`,
      }}
    >
      <div
        className={cx('grid-container', {
          'grid-container--no-background-image': props['remove-default-design'],
        })}
      >
        <div className='grid-x align-center'>
          <div className='cell medium-10'>
            {props.statistic && (
              <h4 className='quote-statistic'>{props.statistic}</h4>
            )}
            <blockquote
              className={cx({
                'no-quotation-marks': props['quotation-marks'] === false,
              })}
              dangerouslySetInnerHTML={{ __html: props.quote }}
            />
            <div className='quote-logo-divider'>
              <span>
                {props['quote-logo'] && (
                  <div
                    className={cx('quote-logo', {
                      'quote-logo--full-bleed': props['logo-icon-full-bleed'],
                    })}
                  >
                    <Image
                      src={props['quote-logo-icon']}
                      alt={props['logo-alt']}
                      width={props.quoteLogoWidth}
                      height={props.quoteLogoHeight}
                    />
                  </div>
                )}
              </span>
            </div>
            <cite dangerouslySetInnerHTML={{ __html: props.cite }} />
            {props['quote-link'] && (
              <Link href={props['quote-link']}>
                <a className='quote-link'>
                  {props['quote-link-text']} <ArrowRightSingleSmall />
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quote;
